import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import FormInput from "app/Components/_form/FormInput/FormInput";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import FormTextArea from "app/Components/_form/FormTextArea/FormTextArea";
import { contractorDropdownLabel, userDropdownLabel } from "app/_helpers/helper";
import {
  useContractorPerson,
  useEmployee,
  useEmployeeDropdown,
} from "app/_helpers/hooks";
import React, { useMemo } from "react";
import { OverlayTrigger, Tooltip, Button, Row, Col } from "react-bootstrap";
// import { Button } from "react-bootstrap/lib/InputGroup";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { TRAINEE_TYPE_OPTION } from "../../TrainingManagement/CONSTANTS";

function WorkmenInteractionTab({
  onChangeWorkmen = () => {},
  formObj = {},
  dataArray = [],
  errorArray = [],
  onChange = () => {},
  onAdd = () => {},
  onDelete = () => {},
  viewOnly,
  disabled = false,
  form,
  contractorsStaff,
}) {
  const [employees, employeesOption] = useEmployeeDropdown();

  return (
    <div className="drillingPlan-plannedEdit">
      <Row>
        <Col lg={6}>
          <FormTextArea
            label={"Brief about on-going Operations"}
            name="operationBrief"
            onChange={onChangeWorkmen}
            value={formObj.operationBrief}
            disabled={viewOnly}
          />
          {/* <FormInput
            value={formObj.operationBrief}
            name="operationBrief"
            onChange={onChangeWorkmen}
            // error={errorArray[index]?.operationBrief}
            label={"Brief about on-going Operations"}
            disabled={viewOnly}
          /> */}
        </Col>
        <Col lg={6}>
          <FormTextArea
            label={"Understanding of the Workmen on Safety"}
            name="workmenUnderstandingOnSafety"
            onChange={onChangeWorkmen}
            value={formObj.workmenUnderstandingOnSafety}
            disabled={viewOnly}
          />

          {/* <FormInput
            value={formObj.workmenUnderstandingOnSafety}
            name="workmenUnderstandingOnSafety"
            onChange={onChangeWorkmen}
            // error={errorArray[index]?.workmenUnderstandingOnSafety}
            disabled={viewOnly}
            label={"Understanding of the Workmen on Safety"}
          /> */}
        </Col>
        <Col lg={6}>
          <FormTextArea
            label={"Safety Briefing Provided to Workmen"}
            name="safetyProvidedToWorkmen"
            onChange={onChangeWorkmen}
            value={formObj.safetyProvidedToWorkmen}
            disabled={viewOnly}
          />

          {/* <FormInput
            value={formObj.safetyProvidedToWorkmen}
            name="safetyProvidedToWorkmen"
            onChange={onChangeWorkmen}
            // error={errorArray[index]?.safetyProvidedToWorkmen}
            disabled={viewOnly}
            label={"Safety Briefing Provided to Workmen"}
          /> */}
        </Col>
        <Col lg={6}>
          <FormTextArea
            label={"Other Remarks"}
            name="remark"
            onChange={onChangeWorkmen}
            value={formObj.remark}
            disabled={viewOnly}
          />

          {/* <FormInput
            value={formObj.remark}
            name="remark"
            // onChange={({ target: { name, value } }) => onChange({ name, value })}
            onChange={onChangeWorkmen}
            // error={errorArray[index]?.remark}
            disabled={viewOnly}
            label={"Other Remarks"}
          /> */}
        </Col>

        <Col lg={6}>
          <FormInput
            value={formObj.numberOfWorkpersons}
            name="numberOfWorkpersons"
            onChange={(event) =>
              event.target.value >= 0 &&
              event.target.value <= 99999 &&
              onChangeWorkmen(event)
            }
            type={"number"}
            //error={errorArray[index]?.remark}
            disabled={viewOnly}
            label={"Number of Workpersons Interacted with"}
          />
        </Col>
      </Row>
      <div className="table-responsive mb-4">
        <table id="user_table" className="table table-bordered mb-0">
          <thead>
            <tr>
              <th scope="col">Type </th>
              <th scope="col">Key Workmen Interacted with</th>

              {!viewOnly && <th scope="col">Remove</th>}
            </tr>
          </thead>
          <tbody>
            {Array.isArray(formObj?.workmenInteractedWith) &&
            formObj?.workmenInteractedWith.length > 0 ? (
              formObj?.workmenInteractedWith.map((x, index) => {
                const traineeOption = (() => {
                  switch (x?.type) {
                    case "employee":
                      return employeesOption?.filter(
                        (obj) => obj?.employmentStatus === "active"
                      );
                    case "contractorPerson":
                      return contractorsStaff
                        ?.filter((d) => +d.contractorId === form?.contractorsId)
                        ?.map((obj) => ({
                          id: obj.id,
                          value: obj.id,
                          label: contractorDropdownLabel(obj),
                        }));

                    default:
                      return [];
                  }
                })();

                return x.deleted ? null : (
                  <tr key={index}>
                    <th>
                      <FormSelect
                        name="type"
                        value={x.type}
                        // onChange={onChange}
                        onChange={({ target: { name, value } }) =>
                          onChange({ name, value, index })
                        }
                        options={TRAINEE_TYPE_OPTION?.filter(
                          (d) =>
                            (d.id === "contractorPerson" && form?.contractorInvolved) ||
                            d.id === "employee"
                        )}
                        // label={"Type"}
                        // error={error?.type}
                        // menuPortalTarget={null}
                      ></FormSelect>
                    </th>

                    <th>
                      <FormSelect
                        name="userId"
                        value={x.userId}
                        // onChange={onChange}
                        onChange={({ target: { name, value } }) =>
                          onChange({ name, value, index })
                        }
                        options={traineeOption}
                        // label={""}
                        // error={error?.userId}
                        // menuPortalTarget={null}
                      ></FormSelect>
                    </th>

                    {!viewOnly && (
                      <td>
                        <div className="actionIconsGroup">
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                          >
                            <span
                              onClick={() => onDelete(index)}
                              className="pointer icons text-danger font-20"
                            >
                              <FiMinusCircle />
                            </span>
                          </OverlayTrigger>
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="10" align="center">
                  {/* <div className="alert alert-danger d-inline-block m-0">
                                <strong>No Evidence</strong>
                            </div> */}
                </td>
              </tr>
            )}
            {!viewOnly && formObj?.workmenInteractedWith?.length !== 10 && (
              <tr>
                <td colSpan="10">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}
                  >
                    <Button className="addRowPluseIcon" onClick={onAdd}>
                      <FiPlusCircle />
                    </Button>
                  </OverlayTrigger>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default WorkmenInteractionTab;
